import { Component, OnInit, Output, ViewEncapsulation, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ManageForeclosureAuctionService } from '../manage-foreclosure-auction.service';
import { ForeclosureAuctionSearchParams } from '../models/ForeclosureAuction'

@Component({
  selector: 'app-add-foreclosure-auction',
  templateUrl: './add-foreclosure-auction.component.html',
  styleUrls: ['./add-foreclosure-auction.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [ManageForeclosureAuctionService]
})
export class AddForeclosureAuctionComponent implements OnInit {
  @Output() cancelAddEvent = new EventEmitter<boolean>();
  @Output() setBreadCrumbs = new EventEmitter<any[]>();
  @Output() objMessage = new EventEmitter<{}>();
  @Output() reload = new EventEmitter<boolean>();

  propertyStates:any[];
  selectedPropertyState: any[];
  county:any[];
  staturtaryValue = 0;
  params: ForeclosureAuctionSearchParams;

  /* ----- Form Groups and Controls ----*/
  public addForeclosureAuctionForm: FormGroup = new FormGroup({
    PropertyStates: new FormControl('', [Validators.required]),
    County: new FormControl('', [Validators.required]),
    AuctionLocationAddress: new FormControl('', [Validators.required, Validators.pattern(/^[^\@$!*%]*$/)]),
    AuctionLocationDetails: new FormControl('', null),
    StatutaryLocation: new FormControl('', null)
  });
  stateControl = this.addForeclosureAuctionForm.get('PropertyStates');
  countyControl = this.addForeclosureAuctionForm.get('County');
  auctionlocationAddress = this.addForeclosureAuctionForm.get('AuctionLocationAddress');
  auctionLocationDetailsControl = this.addForeclosureAuctionForm.get('AuctionLocationDetails');
  statutaryLocationControl = this.addForeclosureAuctionForm.get('StatutaryLocation');
  processing: boolean;


  constructor(private manageForeclosureAuctionService: ManageForeclosureAuctionService) { }

  ngOnInit() {
    this.staturtaryValue = 0;
    this.manageForeclosureAuctionService.getStates().subscribe(data => {
      this.propertyStates = data.filter(x => x.value != 'ALL');
    });
  }

  populateCounty() :void {
     this.manageForeclosureAuctionService.getCounty(this.selectedPropertyState.toString()).subscribe(res => {
       this.county = res.data;
     })
   }

  hideAddForeclosureAuctionForm(): void {
    this.cancelAddEvent.emit(false);
    this.reload.emit(false);
    this.setBreadCrumbs.emit([{ label: 'Manage Foreclosure Auction Location' }]);
  }

  submitAddForeclosureAuctionForm():void {
    this.params = <ForeclosureAuctionSearchParams>{};
    this.processing = true;
    this.params = {
      State : this.stateControl.value, 
      County : this.countyControl.value,
      StatutaryLocation: this.statutaryLocationControl.value,
      LocationAddress: this.auctionlocationAddress.value,
      LocationDetails: this.auctionLocationDetailsControl.value
    }
    this.manageForeclosureAuctionService.save(this.params).subscribe(res => {
      this.processing = false; 
      if(!res.error && res.data.length >0){
        this.objMessage.emit({'severity': 'success', 'detail': 'Foreclosure Auction location added successfully.'});
        this.cancelAddEvent.emit(false);
        this.setBreadCrumbs.emit([{ label: 'Manage Foreclosure Auction Location' }]);
      }else if(res.error && res.data.length == 0){
        this.objMessage.emit({'severity': 'error', 'detail': res.messages[0]});
      }
    }, error => {
      this.processing = false;   
      this.objMessage.emit({'severity': 'error', 'detail': error.message});  
    })
  }

}
